import React from "react";
import "../css/terms.scss";
import PolicyPage from "./PolicyPage";

function Terms() {
  return (
    <PolicyPage title="Terms of Use">
      <p><em>Last updated: October 9, 2026</em></p>
      <p>These terms apply when you browse this website or place an order with danecay. By using the store, you agree to these terms and the policies linked from the website.</p>

      <h2>1. Store Information</h2>
      <p>danecay is a Hong Kong footwear brand. Customer support is available at <a href="mailto:core@danecay.shop">core@danecay.shop</a>. Product images and descriptions are provided to help you make a purchase decision; screen settings and natural materials may cause small colour or grain differences.</p>

      <h2>2. Orders and Acceptance</h2>
      <p>Your checkout submission is an offer to buy. An order is accepted after payment is authorised and we send confirmation. We may decline or cancel an order for suspected fraud, unavailable stock, an obvious pricing error, restricted delivery destination or incomplete information. If payment has already been captured, the affected amount will be refunded.</p>

      <h2>3. Prices and Payment</h2>
      <p>Prices are shown in USD unless the checkout states otherwise. A flat USD 9.99 shipping charge is added to each order. Payment is handled by an external payment provider; danecay does not collect card numbers on this website.</p>

      <h2>4. Product Availability</h2>
      <p>Small production runs can sell out. If an item becomes unavailable after ordering, we will contact you using the checkout email and offer a replacement, wait option or refund.</p>

      <h2>5. Delivery and Returns</h2>
      <p>Estimated preparation and transit times are not guarantees because carrier and customs events may occur outside our control. Our Shipping Policy and Returns Policy form part of these terms.</p>

      <h2>6. Acceptable Use</h2>
      <p>You may not misuse the site, interfere with security, submit false checkout information, attempt unauthorised access, scrape the store at disruptive volume, or copy danecay content for commercial use without permission.</p>

      <h2>7. Intellectual Property</h2>
      <p>The danecay name, logo, original product imagery, written content and site materials belong to danecay or are used with permission. You may use the site for personal shopping but may not reproduce or sell its content without written permission.</p>

      <h2>8. Liability</h2>
      <p>Nothing in these terms excludes rights or liabilities that cannot lawfully be excluded. To the extent permitted by law, danecay is not responsible for indirect loss or loss caused by misuse, normal wear, failure to follow care guidance, or events outside reasonable control.</p>

      <h2>9. Governing Law and Changes</h2>
      <p>These terms are governed by the laws of Hong Kong, without limiting mandatory consumer rights that apply where you live. We may revise the terms prospectively by posting an updated version and revision date.</p>
    </PolicyPage>
  );
}

export default Terms;
